import { initReactI18next } from 'react-i18next';
import i18n, { use } from 'i18next';

import enGB from 'locales/en-GB.json';
import enUS from 'locales/en-US.json';
import C from 'utils/values/constant.util';

const EN_GB_TRANSLATIONS = Object.freeze({
  translation: enGB,
});

const EN_US_TRANSLATIONS = Object.freeze({
  translation: enUS,
});

const resources = C({
  'en-GB': EN_GB_TRANSLATIONS,
  'en-US': EN_US_TRANSLATIONS,
});

use(initReactI18next).init({
  resources,
  fallbackLng: 'en-GB',
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export default i18n;
